import { render, staticRenderFns } from "./DonationManagement.vue?vue&type=template&id=24404f2f&scoped=true"
import script from "./DonationManagement.vue?vue&type=script&lang=js"
export * from "./DonationManagement.vue?vue&type=script&lang=js"
import style0 from "./DonationManagement.vue?vue&type=style&index=0&id=24404f2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24404f2f",
  null
  
)

export default component.exports